"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logPendingRequestSchema = void 0;
const zod_1 = require("zod");
const subjectField_schema_1 = require("../../../common/schemas/subjectField.schema");
const userWithUserId_schema_1 = require("../../../common/schemas/userWithUserId.schema");
const contact_schema_1 = require("../../../common/schemas/contact.schema");
const selectedItem_schema_1 = require("../../../common/schemas/selectedItem.schema");
const CpmsIntegration_1 = require("../../../common/cpms/CpmsIntegration");
const longField_schema_1 = require("../../../common/schemas/longField.schema");
const attachments_schema_1 = require("../../../common/schemas/attachments.schema");
const comment_schema_1 = require("../../../common/schemas/comment.schema");
exports.logPendingRequestSchema = zod_1.z
    .object({
    subject: subjectField_schema_1.subjectFieldSchema,
    from: contact_schema_1.contactSchema,
    to: userWithUserId_schema_1.userWithUserIdSchema.array().nonempty(),
    receivedVia: (0, selectedItem_schema_1.selectedItemWithSpecificTypeSchema)(CpmsIntegration_1.CpmsIntegration),
    sender: zod_1.z
        .object({
        id: zod_1.z.string().min(1),
        number: zod_1.z.string().min(1),
        revisionNumber: zod_1.z.string().optional(),
        specSectionNumber: zod_1.z.string().optional(),
        specSectionDescription: zod_1.z.string().optional(),
    })
        .strict(),
    purpose: selectedItem_schema_1.selectedItemSchema,
    description: longField_schema_1.longFieldSchema.optional(),
    attachments: attachments_schema_1.optionalAttachmentsSchema,
    comments: comment_schema_1.commentSchema.array().nonempty().optional(),
})
    .strict();
//# sourceMappingURL=logPendingRequest.schema.js.map